import { render } from "./AddAddessForm.vue?vue&type=template&id=548c6a03"
import script from "./AddAddessForm.vue?vue&type=script&lang=js"
export * from "./AddAddessForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__